/**
 * Chemins de la feature `referral` — centralisés pour éviter les paths hardcodés
 * dans les vues, routes et navigation (cf. front/CLAUDE.md §3).
 */
export const REFERRAL_PATHS = {
  /** Écran « Mon parrainage » : mon code + mon wallet (solde + historique). */
  root: '/referral',
} as const;
